export default {
  install(Vue, _options) {
    // for global Snackbar
    Vue.prototype.$showSnackbar = function ({
      store = this.$store,
      ...snackbar
    }) {
      store.commit('set_snackbar', snackbar)
      store.commit('set_showSnackbar', true)
    }
    Vue.prototype.$showSuccessbar = function (message, timeout, options) {
      this.$showSnackbar({
        ...options,
        color: 'success',
        text: message || 'Success!',
        timeout: timeout
      })
    }
    Vue.prototype.$showErrorbar = function (message, timeout, options) {
      this.$showSnackbar({
        ...options,
        color: 'error',
        text: message || 'An error occurred.',
        timeout
      })
    }
    Vue.prototype.$showInfobar = function (message, timeout, options) {
      this.$showSnackbar({
        ...options,
        color: 'info',
        text: message,
        timeout: timeout
      })
    }
    Vue.prototype.$hideSnackbar = function () {
      this.$store.commit('set_showSnackbar', false)
    }
  }
}
